var _g, _path, _path2, _path3, _path4, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlanOnboarding3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 56,
    r: 42,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 34.5h25a3.5 3.5 0 0 1 3.5 3.5v20.625a8.6 8.6 0 0 1 1.5 1.398V38a5 5 0 0 0-5-5H40a5 5 0 0 0-5 5v35a5 5 0 0 0 5 5h25a5 5 0 0 0 5-5v-2.022a8.6 8.6 0 0 1-1.5 1.397V73a3.5 3.5 0 0 1-3.5 3.5H40a3.5 3.5 0 0 1-3.5-3.5V38a3.5 3.5 0 0 1 3.5-3.5",
    fill: "#13123A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.166 45.462V49h-.789v-3.538h-1.363v-.74h3.533v.74zm-3.62-.739h.788V49h-.788zm-4.34 2.652v-2.652h.788v2.652q0 .238.08.415.085.171.214.294a.96.96 0 0 0 .654.232q.177 0 .348-.055.171-.06.306-.177a.9.9 0 0 0 .213-.294q.08-.177.08-.415v-2.652h.788v2.652q0 .44-.153.776-.146.33-.39.556a1.6 1.6 0 0 1-.557.33 1.9 1.9 0 0 1-1.27 0 1.6 1.6 0 0 1-.557-.33 1.8 1.8 0 0 1-.397-.556 1.9 1.9 0 0 1-.147-.776m-2.001-1.913V49h-.788v-3.538h-1.363v-.74h3.532v.74zm-4.079-.8h.128l1.998 4.339h-.819l-.263-.568h-1.955l-.269.568h-.813zm.702 3.031-.635-1.375-.642 1.375zM43.463 49v-4.277h1.35q.422 0 .721.146.3.146.477.38.177.225.232.512a1.3 1.3 0 0 1-.012.557q-.06.275-.25.513a1.2 1.2 0 0 1-.49.36l1.204 1.81h-.94l-1.1-1.681h-.404V49zm.788-3.532v1.106h.562a.7.7 0 0 0 .36-.08.6.6 0 0 0 .22-.207.46.46 0 0 0 .068-.263.5.5 0 0 0-.073-.269.5.5 0 0 0-.214-.201.7.7 0 0 0-.36-.086zm-3.108 3.624q-.55 0-.966-.19-.415-.195-.69-.507a2.2 2.2 0 0 1-.416-.715 2.58 2.58 0 0 1 0-1.638q.14-.402.416-.715.274-.31.69-.5.416-.196.966-.196.342 0 .672.116.33.11.605.318l-.452.641a1.2 1.2 0 0 0-.349-.201 1.2 1.2 0 0 0-.47-.092q-.465 0-.776.214a1.35 1.35 0 0 0-.459.538 1.6 1.6 0 0 0-.152.696q0 .373.152.697.153.324.459.538.312.214.776.214.238 0 .397-.05.16-.054.263-.121v-.734h-.966v-.74h1.76v1.914q-.268.213-.654.366a2.3 2.3 0 0 1-.806.147m16.573-9.137a1 1 0 0 0 .49.36q.299.092.616.092.11 0 .245-.024a1 1 0 0 0 .25-.08.6.6 0 0 0 .196-.146.37.37 0 0 0 .08-.238q0-.195-.178-.33a2 2 0 0 0-.434-.251 15 15 0 0 0-.574-.238 3.5 3.5 0 0 1-.568-.288 1.7 1.7 0 0 1-.44-.409 1 1 0 0 1-.172-.593q0-.318.123-.556.121-.238.33-.397.207-.158.47-.239.27-.08.562-.079.421 0 .82.171.396.165.696.459l-.52.574a1.5 1.5 0 0 0-.47-.312 1.37 1.37 0 0 0-.807-.092.7.7 0 0 0-.22.086.4.4 0 0 0-.159.16.5.5 0 0 0-.055.25q0 .171.172.293.177.116.44.226l.574.232q.306.116.568.294.27.177.44.433.177.25.178.63 0 .318-.141.55a1.2 1.2 0 0 1-.367.385q-.226.153-.507.226-.281.08-.562.08-.239 0-.477-.043a2.2 2.2 0 0 1-.458-.135 2.2 2.2 0 0 1-.41-.232 1.8 1.8 0 0 1-.336-.342zm-2.196-3.232h.79V41h-.79zm-4.797 0h.813l1.246 2.682 1.24-2.682h.82l-1.998 4.339h-.129zM47.387 41v-4.277h2.786v.733h-1.998v1.039h1.552v.733h-1.552v1.04h1.992V41zm-4.291-4.277h1.277q.544.006.953.19.41.182.679.488.275.3.409.684a2.22 2.22 0 0 1 0 1.559q-.135.378-.41.684-.269.3-.678.483a2.4 2.4 0 0 1-.953.19h-1.277zm.788.733v2.805h.458q.465 0 .77-.208.312-.207.465-.52a1.46 1.46 0 0 0 .159-.672q0-.366-.153-.678a1.3 1.3 0 0 0-.465-.52q-.31-.207-.776-.207z",
    fill: "#13123A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 55.75a.75.75 0 0 1 .75-.75h21a.75.75 0 0 1 0 1.5h-21a.75.75 0 0 1-.75-.75m0 7.5a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75m0 7.5a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75",
    fill: "#13123A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m60 65.677 2.824 2.823L68 62.384",
    stroke: "#E5A033",
    strokeWidth: 1.412,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 65.5,
    r: 7.75,
    stroke: "#E5A033",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4816_19186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4816_19186",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlanOnboarding3);
export default __webpack_public_path__ + "static/media/ic_plan_onboarding_3.c6f7f83204cd833194870d7a31a6e113.svg";
export { ForwardRef as ReactComponent };